import { InferType, object, string } from 'yup';

export const duplicateTemplateValidationSchema = object().shape({
  name: string()
    .required('Please fill the document name')
    .min(3, 'Must be at least 3 characters')
    .max(255, 'Document name should not exceed 255 characters'),
});

export type DuplicateDocumentTemplateFormFields = InferType<
  typeof duplicateTemplateValidationSchema
>;
